const obj = {
  server: {
    api: "http://localhost:5010",
    stock: "https://scan-dev.warriortrading.com",
    identity: "http://localhost:5678",
    sim: "http://localhost:5020",
  },
  scannerServers: [
    {
      name: "scan-dev",
      value: "https://scan-dev.warriortrading.com",
      down: "",
      up: "",
    },
    {
      name: "scan-qa",
      value: "https://scan-qa.warriortrading.com",
      down: "https://scan-qa.warriortrading.com/ops-api/v1/down-hpas",
      up: "https://scan-qa.warriortrading.com/ops-api/v1/up-hpas",
    },
  ],
};

export default obj;
